module.exports = __webpack_public_path__ + "img/icon-auto-registration2.bcee2824.svg";